import { queryOptions } from "@-/com.npmjs.tanstack__react-query";
import { useCallback } from "react";
import {
  morphemeMnemonicsPanelMorphemeSliceQueryFn,
  useGetMorphemeMnemonicsPanelMorphemeSliceQueryKey,
} from "#read-morpheme-mnemonics-panel-morpheme-slice";
import {
  morphemeMnemonicsPanelMorphemeUserSliceQueryFn,
  useGetMorphemeMnemonicsPanelMorphemeUserSliceQueryKey,
} from "#read-morpheme-mnemonics-panel-morpheme-user-slice";
import {
  infoGraphemeMorphemeSliceQueryFn,
  useGetReferenceGraphemeMorphemeSliceQueryKey,
} from "#read-info-grapheme-morpheme-slice";
import {
  infoWordMorphemeSliceQueryFn,
  useGetReferenceWordMorphemeSliceQueryKey,
} from "#read-info-word-morpheme-slice";

/** Query options for every slice the morpheme panels read (mnemonics readonly + user, info grapheme + word). */
export function useGetMorphemePanelsSlicesQueries() {
  const getMorphemeMnemonicsPanelMorphemeUserSliceQueryKey =
    useGetMorphemeMnemonicsPanelMorphemeUserSliceQueryKey();
  const getMorphemeMnemonicsPanelMorphemeSliceQueryKey =
    useGetMorphemeMnemonicsPanelMorphemeSliceQueryKey();
  const getReferenceGraphemeMorphemeSliceQueryKey = useGetReferenceGraphemeMorphemeSliceQueryKey();
  const getReferenceWordMorphemeSliceQueryKey = useGetReferenceWordMorphemeSliceQueryKey();

  return useCallback(
    (morpheme: string) => ({
      infoGraphemeMorphemeSliceQueryOptions: queryOptions({
        queryFn: infoGraphemeMorphemeSliceQueryFn,
        queryKey: getReferenceGraphemeMorphemeSliceQueryKey(morpheme),
      }),
      infoWordMorphemeSliceQueryOptions: queryOptions({
        queryFn: infoWordMorphemeSliceQueryFn,
        queryKey: getReferenceWordMorphemeSliceQueryKey(morpheme),
      }),
      mnemonicsPanelMorphemeSliceQueryOptions: queryOptions({
        queryFn: morphemeMnemonicsPanelMorphemeSliceQueryFn,
        queryKey: getMorphemeMnemonicsPanelMorphemeSliceQueryKey(morpheme),
      }),
      mnemonicsPanelMorphemeUserSliceQueryOptions: queryOptions({
        queryFn: morphemeMnemonicsPanelMorphemeUserSliceQueryFn,
        get queryKey() {
          return getMorphemeMnemonicsPanelMorphemeUserSliceQueryKey(morpheme);
        },
      }),
    }),
    [
      getMorphemeMnemonicsPanelMorphemeSliceQueryKey,
      getMorphemeMnemonicsPanelMorphemeUserSliceQueryKey,
      getReferenceGraphemeMorphemeSliceQueryKey,
      getReferenceWordMorphemeSliceQueryKey,
    ],
  );
}

export type MorphemePanelsSlicesPrefetchQueries = ReturnType<
  ReturnType<typeof useGetMorphemePanelsSlicesQueries>
>;
